var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 0H2.375C1.32031 0 0.5 0.859375 0.5 1.875V13.125C0.5 14.1797 1.32031 15 2.375 15H18.625C19.6406 15 20.5 14.1797 20.5 13.125V1.875C20.5 0.859375 19.6406 0 18.625 0ZM2.375 1.25H18.625C18.9375 1.25 19.25 1.5625 19.25 1.875V3.51562C18.3906 4.21875 17.1406 5.23438 13.3516 8.24219C12.6875 8.78906 11.3984 10.0391 10.5 10C9.5625 10.0391 8.27344 8.78906 7.60938 8.24219C3.82031 5.23438 2.57031 4.21875 1.75 3.51562V1.875C1.75 1.5625 2.02344 1.25 2.375 1.25ZM18.625 13.75H2.375C2.02344 13.75 1.75 13.4766 1.75 13.125V5.11719C2.60938 5.85938 4.01562 6.99219 6.82812 9.21875C7.64844 9.88281 9.05469 11.2891 10.5 11.25C11.9062 11.2891 13.3125 9.88281 14.1328 9.21875C16.9453 6.99219 18.3516 5.85938 19.25 5.11719V13.125C19.25 13.4766 18.9375 13.75 18.625 13.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c4228619.svg";
export { ForwardRef as ReactComponent };